import { Col, Form, Input, Row, Select, Typography } from "antd";
import { getLoggedUser } from "explorer/reducers/users";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PhoneWithDDD from "shared/components/phone-with-ddd/PhoneWithDDD";
import { filterOptionDiacritics } from "shared/components/single-multiselect/SingleMultiselect";
import { LinguagemEnum } from "shared/enums/LinguagemEnum";
import { validatePhone } from "shared/helpers/phone-helpers";
import { saveLoggedUser } from "shared/service/StrmService";

const DetalhesConta: React.FC<any> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const loggedUser = useSelector((state: any) => state.users.loggedUser);
  const { countryOptions } = useSelector((state: any) => state.countries);
  const countryCodeValue = Form.useWatch("countryCode", form);
  const dispatch = useDispatch();
  const onFinish = async () => {
    await form.validateFields();
    setLoading(true);
    const {
      actions,
      activeSubscriptionTeam,
      mercadoPagoTransactions,
      userTeam,
      ...rest
    }: any = form.getFieldsValue(true);
    try {
      await saveLoggedUser(rest);
      toast.success<string>(t("pages.MeusDados.sucesso"));
      dispatch(getLoggedUser());
    } catch (error: any) {
      toast.error(error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [loggedUser, form]);

  return (
    <div>
      <h5 style={{ padding: 0 }} className="heading-h5">
        {t("pages.MeusDados.titulo")}
      </h5>
      <Typography.Title level={5} style={{ color: "#fff" }}>
        {t("pages.MeusDados.creditosRemanescentes", {
          creditos: loggedUser.remainingCredits,
        })}
      </Typography.Title>

      <Form
        form={form}
        initialValues={loggedUser}
        onFinish={onFinish}
        style={{ color: "#fff", marginTop: "15px" }}
        layout="vertical"
      >
        <Row gutter={32}>
          <Col xs={24}>
            <Form.Item
              name="currentLanguage"
              label={t("pages.MeusDados.language")}
            >
              <Select>
                <Select.Option value={LinguagemEnum.Ingles}>
                  {t("pages.MeusDados.english")}
                </Select.Option>
                <Select.Option value={LinguagemEnum.Portugues}>
                  {t("pages.MeusDados.portuguese")}
                </Select.Option>
                <Select.Option value={LinguagemEnum.Espanhol}>
                  {t("pages.MeusDados.spanish")}
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item
              name="name"
              label={t("pages.MeusDados.fullName")}
              rules={[
                {
                  required: true,
                  message: t("pages.MeusDados.nomeObrigatorio"),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={24}>
            <Form.Item name="login" label={t("pages.MeusDados.email")}>
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={24}>
            <Form.Item label={t("pages.MeusDados.phone")}>
              <PhoneWithDDD
                names={{
                  ddi: "ddi",
                  phoneCountry: "countryCodePhone",
                  phone: "phone",
                }}
                rules={{
                  ddi: [
                    {
                      required: countryCodeValue === "BR",
                      message: t("quiz.pages.Questionario.dddRequired"),
                    },
                  ],
                  phone: [
                    {
                      required: countryCodeValue === "BR",
                      message: t("quiz.pages.Questionario.phoneRequired"),
                    },
                    {
                      validator(_: any, value: any) {
                        const { countryCodePhone } = form.getFieldsValue();
                        return validatePhone(
                          countryCodePhone,
                          value,
                          t("pages.MeusDados.telefoneInvalido")
                        );
                      },
                    },
                  ],
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={24}>
            <Form.Item name="countryCode" label={t("pages.MeusDados.country")}>
              <Select
                showSearch
                options={countryOptions}
                filterOption={filterOptionDiacritics}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={24}>
            <Form.Item name="state" label={t("pages.MeusDados.state")}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={24}>
            <Form.Item name="city" label={t("pages.MeusDados.city")}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={12} offset={6}>
            <button
              className="botao-roxo"
              style={{ width: "100%" }}
              disabled={loading}
            >
              {t("pages.MeusDados.alterar")}
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default DetalhesConta;
